import {
	BankIdButton,
	Box,
	Column,
	FloatBox,
	NumberedSteps,
	Paragraph,
	Text,
	styled,
} from '@mybonus/ui';

export const ContentBox = styled(FloatBox)`
	width: 100%;
`;

export const StageInset = styled(Box)`
	width: 100%;
	padding: ${({ theme }) => theme.space.sm}px;
`;

export const GateStage = styled(Box)`
	position: relative;
	overflow: hidden;
	width: 100%;
	min-height: 75vh;
	padding: ${({ theme }) => theme.space.lg}px;
	border-radius: ${({ theme }) => theme.rounding.md}px;
	background: linear-gradient(
			150deg,
			hsla(160, 62%, 18%, 0.18) 0%,
			hsla(153, 56%, 20%, 0.42) 48%,
			hsla(150, 44%, 14%, 0.56) 100%
		),
		url('/assets/images/offerwall-blurred.jpg') center / cover no-repeat;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const GatePanel = styled(FloatBox)`
	position: relative;
	z-index: 1;
	width: 100%;
	max-width: ${({ theme }) => theme.space.xxl * 6}px;
	padding: ${({ theme }) => theme.space.md}px;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	background: ${({ theme }) => theme.color.white.base};
`;

export const GateHeader = styled(Column)`
	margin-bottom: ${({ theme }) => theme.space.sm}px;
	align-items: center;
	gap: ${({ theme }) => theme.space.xs}px;
	text-align: center;
`;

export const GateDescription = styled(Paragraph)`
	margin-top: 0;
	margin-bottom: 0;
	color: ${({ theme }) => theme.color.gray.base};
	line-height: 1.6;
	text-align: center;
`;

export const GateSteps = styled(NumberedSteps)`
	margin: ${({ theme }) => theme.space.sm}px 0;
`;

export const GateStepText = styled(Paragraph)`
	margin-top: 0;
	margin-bottom: 0;
	color: ${({ theme }) => theme.color.gray.base};
	line-height: 1.5;
`;

export const IdentificationGateWrapper = styled(Box)`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const GateAction = styled(Box)`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: ${({ theme }) => theme.space.md}px;
	max-width: 400px;
`;

export const GateBankIdButton = styled(BankIdButton)`
`;

export const IframeWrapper = styled(Box)`
	width: 100%;
	min-height: 75vh;
`;

export const Iframe = styled('iframe')`
	width: 100%;
	min-height: 75vh;
	border: 0;
	border-radius: ${({ theme }) => theme.rounding.md}px;
	background: ${({ theme }) => theme.color.white.base};
`;
